import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { LocalStorageService } from 'ngx-store';
import { RemoteService } from 'app/services/remote.service';
import { Router } from '@angular/router';
import { ShareService } from 'app/services/share.service';
import { STATUS_CONSTANTS } from "app/services/STATUS_CONSTANTS";
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  login: FormGroup;
  hide = true;
  formSumitAttempt: boolean;

  constructor(private fb: FormBuilder,
    private notifierService: NotifierService,
    private ls: LocalStorageService,
    private remoteService: RemoteService,
    private router: Router,
    private shareService: ShareService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.dialog.closeAll();
    this.login = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9A-Z.!#$%^&+;*_)(-]{3,}[@]{1}[a-z]{2,}[.]{1}[a-z]{2,}$')]],
      password: ['', [Validators.required]],
      rememberMe: false
    });
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    document.getElementById("myForm").style.display = "none";
    this.remoteService.scrollingtoNavbar();
    this.remoteService.sessionIsShow = false;
  }

  submit() {
    const payload = {
      username: this.login.value.email,
      password: this.login.value.password
    }
    this.shareService.User(payload);
    if (this.login.valid) {
      this.remoteService.login(payload).subscribe(res => {
        if (res.access_token) {
          const payload = {
            "accessToken": res.access_token,
            "email": this.login.value.email
          }
          this.ls.set('userName', this.login.value.email);
          this.ls.set('access_token', res.access_token);
          this.ls.set('refresh_token', res.refresh_token);
          this.ls.set('tokenDetails', res);
          this.remoteService.getAccessingRole(payload).subscribe(resRole => {
            if (resRole) {
              this.remoteService.showSpinner();
              this.ls.set('role', 'admin');
              this.router.navigate(['/admin/admin-dashboard']);
            } else {
              this.remoteService.showSpinner();
              this.ls.set('role', 'user');
              this.router.navigate(['/user/my-portfolios']);
            }
            this.notifierService.notify('success', 'Login successfully!');
          }, error => {
            this.remoteService.showSpinner();
            this.ls.set('role', 'user');
            this.router.navigate(['/user/my-portfolios']);
          })
        }
      }, error => {
        const data = {
          text: error.error.message,
          type: 'warning'
        }
        this.remoteService.openSweetAlert(data);
      })
    } else {
      this.notifierService.notify('error', 'Invalid Inputs!');
    }
  }

  loginSubmit(event) {
    if (event.keyCode === 13) {
      this.submit();
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.login.get(field).valid && this.login.get(field).touched) ||
      (this.login.get(field).untouched && this.formSumitAttempt)
    );
  }

  onSubmit() {
    this.formSumitAttempt = true;
  }
}
